import React from "react";
import { YhCard } from "../../../ui/YhCard";

interface CustomProps {
  cardContent: React.ReactNode;
}

const CustomCard = (props: CustomProps) => {
  return (
    <YhCard className="w-full max-w-[420px] border-0 bg-white shadow-[0_8px_40px_rgba(15,23,42,0.08)]">
      {props.cardContent}
    </YhCard>
  );
};

export default CustomCard;
